import { MessageTouchPoint } from "@kahunmedical/common-configuration/dist/configuration/messageTemplate";

export enum SupportedCommunicationPlatforms {
  Whatsapp = "whatsapp",
  Email = "email",
  SMS = "sms",
}

export interface SendMessageParams {
  touchPoint: MessageTouchPoint;
  to: string;
  locale?: string;
  macroFields?: Record<string, string>;
}
